export var ZoneType;
(function (ZoneType) {
    ZoneType["Content"] = "CONTENT";
    ZoneType["RichContent"] = "RICH_CONTENT";
    // Query = 'QUERY',
    // ExpertQuery = 'EXPERT_QUERY',
    // GeneratedContent = 'GENERATED_CONTENT',
})(ZoneType || (ZoneType = {}));
export var NavigationType;
(function (NavigationType) {
    NavigationType["Value"] = "Value";
    NavigationType["Range"] = "Range";
})(NavigationType || (NavigationType = {}));
export var DefaultValues;
(function (DefaultValues) {
    DefaultValues["Unbound"] = "Unbound";
})(DefaultValues || (DefaultValues = {}));
